// extracted by mini-css-extract-plugin
export var progressContainer = "_j2-0";